// import React from "react";
import React, { Fragment, useState, useEffect } from "react";
import { Link } from "react-router-dom";
// image
import logo from "../../images/logo-full.png";
import swalMessage from "@sweetalert/with-react";
import swal from "sweetalert";
import {
  updatePWDstaffDetails
} from "../../apiservicescall/api";


const ForgotPassword = ({ history }) => {
  const [password, setPassword] = useState("");
  const [resetpassword, setResetpassword] = useState("");
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("userDetails"))
  );

  // const onSubmit = (e) => {
  //   e.preventDefault();
  //   history.push("/dashboard");
  // };

  useEffect(() => {
    console.log("userDetails1232", userDetails)
  }, []);


  const updatePWDstaff = async () => {

    let compCode = userDetails?.userId;
    let outletCode = userDetails?.userId;
    let password = resetpassword;
    let userId = userDetails?.userId;

    let reqforupload = await updatePWDstaffDetails(
      compCode,
      outletCode,
      password,
      userId);

    if (reqforupload?.status === 200) {
      swal("Success!", "Password Updated Succcesfully", "success");

      history.push("/login");

      // window.location.href = "/fis/foods/login";
      //   // await this.setState({ reload: false });
      //   // NotificationManager.success("Success");
      //   // this.setState({ addNewUserModal: false, loading: true });
    } else {
      //   // await this.setState({ reload: false });
      //   // NotificationManager.warning("Invalid Data Format");
      //   // this.setState({ addNewUserModal: true });
      swal("Oops", "Error, Please Try Later", "error");
      // window.location.href = "/fis/foods/login";
      history.push("/login");
      //   setIsview(false);
      //   setIsedit(false);
      //   setLargeModal(!largeModal);
      //   getstaffMasterList();
    }
  };



  return (
    <div className="authincation h-100 p-meddle">
      <div className="container h-100">
        <div className="row justify-content-center h-100 align-items-center">
          <div className="col-md-6">
            <div className="authincation-content">
              <div className="row no-gutters">
                <div className="col-xl-12">
                  <div className="auth-form">
                    <div className="text-center mb-3">
                    </div>
                    <h4 className="text-center mb-4 ">Reset Password</h4>
                    <form>
                      <div className="form-group">
                        <label className="">
                          <strong>Password</strong>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={password}
                          onChange={(e) => {
                            setPassword(e.target.value)
                          }
                          }
                        />
                      </div>

                      <div className="form-group">
                        <label className="">
                          <strong>Retype Password</strong>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={resetpassword}
                          onChange={(e) => {
                            setResetpassword(e.target.value)
                          }
                          }
                        // defaultValue="hello@example.com"
                        />
                      </div>


                      <div className="text-center">
                        <button
                          type="submit"
                          disabled={resetpassword != password}
                          className="btn btn-primary btn-block"
                          onClick={() => {
                            updatePWDstaff()
                          }}
                        >
                          SUBMIT
                        </button>
                      </div>

                      <div className="new-account mt-3">
                        <p className="">
                          Back to login page ? {""}
                          <Link className="text-primary" to="./login">
                            {""}{""} Login
                          </Link>
                        </p>
                      </div>

                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
